// extracted by mini-css-extract-plugin
export default {"main":"styles_main__fBo8J","icons":"styles_icons__atZcN","icon":"styles_icon__Sr-hh"};